import { HttpService } from './http.service';
import { DoctorModel } from '../resources/models';

export class DoctorsService {
  static find(id: string, hasSpinner = true): Promise<DoctorModel> {
    return HttpService.get(`/doctors/${id}`, {}, hasSpinner).then(
      (result) => new DoctorModel({ ...result.data, language: result.data.language || 'en' }),
    );
  }
  static findPublic(id: string, hasSpinner = true): Promise<DoctorModel> {
    return HttpService.get(`/doctors/public/${id}`, {}, hasSpinner).then((result) => {
      const data = result?.data ?? result;
      return new DoctorModel({ ...data, language: data?.language || 'en' });
    });
  }
}
